// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyAZAyM_sDQQnFPAYlXH7R0d70DMFqHIf8Y",
    authDomain: "drproject-345a5.firebaseapp.com",
    databaseURL: "https://drproject-345a5.firebaseio.com",
    projectId: "drproject-345a5",
    storageBucket: "drproject-345a5.appspot.com",
    messagingSenderId: "874342864603",
    appId: "1:874342864603:web:ccd5f909045a6e83b05efe",
    measurementId: "G-RHJKNPR128"
  },
  googleMapsKey: "AIzaSyAZAyM_sDQQnFPAYlXH7R0d70DMFqHIf8Y" //AIzaSyBvXG8eNajmuIo_bj6yy7DUME3RJgDRwNs
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
